import React from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { getNewGameURL } from './utils';
import { useNavigate } from 'react-router-dom';

const TIMER_COLORS = ['#12B8A0', '#FFC42E', '#FF7A1A', '#FF5470'];
const FINAL_COUNTDOWN = 60;

const GlobalMessage = ({ msg, currentTurn, gameOverMessage, handleGameOver, settings }) => {
    const navigate = useNavigate();

    const newGame = () => navigate(getNewGameURL(settings));

    const toastClass =
        msg && msg.type === 'Correct' ? 'sg-toast--correct'
        : msg && msg.type === 'Incorrect' ? 'sg-toast--incorrect'
        : 'sg-toast--neutral';

    const toastIcon =
        msg && msg.type === 'Correct' ? '🎉'
        : msg && msg.type === 'Incorrect' ? '🫧'
        : '💬';

    return (
        <>
            {msg && msg.text && (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '2px 14px' }}>
                    <div key={msg.text} className={`sg-toast ${toastClass} sg-anim-pop`}>
                        <span style={{ fontSize: '1.05rem' }}>{toastIcon}</span>
                        <span>{msg.text}</span>
                    </div>
                </div>
            )}

            {currentTurn === -1 && (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '14px' }}>
                    <div className="sg-card sg-anim-pop" style={{ textAlign: 'center', maxWidth: '420px' }}>
                        <div className="sg-kicker" style={{ color: 'var(--bubblegum)' }}>Last call</div>
                        <h3 style={{ fontSize: '1.5rem', margin: '6px 0 4px' }}>The bag is empty!</h3>
                        <p className="sg-muted" style={{ margin: '0 0 14px', fontWeight: 600 }}>
                            Squeeze out your final words before the timer runs out.
                        </p>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <CountdownCircleTimer
                                isPlaying={currentTurn === -1}
                                duration={FINAL_COUNTDOWN}
                                size={68}
                                strokeWidth={7}
                                trailColor="#F6E2C2"
                                colors={TIMER_COLORS}
                                colorsTime={[40, 25, 10, 0]}
                                onComplete={() => handleGameOver()}
                            >
                                {({ remainingTime }) => (
                                    <span style={{ fontWeight: 900, fontSize: '1.5rem', color: 'var(--ink)' }}>{remainingTime}</span>
                                )}
                            </CountdownCircleTimer>
                        </div>
                    </div>
                </div>
            )}

            {currentTurn === -2 && gameOverMessage && (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '14px' }}>
                    <div className="sg-card sg-anim-pop" style={{ textAlign: 'center', maxWidth: '440px' }}>
                        <div style={{ fontSize: '2.4rem', lineHeight: 1 }}>🏆</div>
                        <h2 style={{ fontSize: '2rem', margin: '8px 0 2px' }}>Game over!</h2>
                        <p style={{ margin: '0 0 16px', fontWeight: 700, color: 'var(--ink-soft)' }}>{gameOverMessage}</p>
                        <div className="sg-wrap" style={{ gap: '10px', justifyContent: 'center' }}>
                            <button className="sg-btn sg-btn--primary" onClick={newGame}>Play again</button>
                            <button className="sg-btn sg-btn--ghost" onClick={handleGameOver}>Show stats</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default GlobalMessage;
